import AWS from 'aws-sdk'
import { Auth } from 'aws-amplify'
AWS.config.update({ region: 'ap-northeast-1' })

export interface DynamoDB {
  query (params: AWS.DynamoDB.DocumentClient.QueryInput): Promise<AWS.DynamoDB.DocumentClient.QueryOutput>
  scan (params: AWS.DynamoDB.DocumentClient.ScanInput): Promise<AWS.DynamoDB.DocumentClient.ScanOutput>
  update (params: AWS.DynamoDB.DocumentClient.UpdateItemInput): Promise<AWS.DynamoDB.DocumentClient.UpdateItemOutput>
  put (params: AWS.DynamoDB.DocumentClient.PutItemInput): Promise<AWS.DynamoDB.DocumentClient.PutItemOutput>
  delete (params: AWS.DynamoDB.DocumentClient.DeleteItemInput): Promise<AWS.DynamoDB.DocumentClient.DeleteItemOutput>
}

export class LocalDynamoDB implements DynamoDB {
  db: AWS.DynamoDB.DocumentClient
  constructor () {
    this.db = new AWS.DynamoDB.DocumentClient()
  }
  query (params: AWS.DynamoDB.DocumentClient.QueryInput): Promise<AWS.DynamoDB.DocumentClient.QueryOutput> {
    return this.db.query(params).promise().then((result) => {
      return {
        Items: result.Items,
        Count: result.Count,
        LastEvaluatedKey: result.LastEvaluatedKey
      }
    }).catch((e) => {
      throw e
    })
  }
  async scan (params: AWS.DynamoDB.DocumentClient.ScanInput): Promise<AWS.DynamoDB.DocumentClient.ScanOutput> {
    return this.db.scan(params).promise().then((result) => {
      return result
    })
  }
  update (params: AWS.DynamoDB.DocumentClient.UpdateItemInput): Promise<AWS.DynamoDB.DocumentClient.UpdateItemOutput> {
    return this.db.update(params).promise()
  }

  put (params: AWS.DynamoDB.DocumentClient.PutItemInput): Promise<AWS.DynamoDB.DocumentClient.PutItemOutput> {
    return this.db.put(params).promise()
  }
  delete (params: AWS.DynamoDB.DocumentClient.DeleteItemInput): Promise<AWS.DynamoDB.DocumentClient.DeleteItemOutput> {
    return this.db.delete(params).promise()
  }
}

export class AuthDynamoDB implements DynamoDB {
  constructor () {
  }
  async query (params: AWS.DynamoDB.DocumentClient.QueryInput): Promise<AWS.DynamoDB.DocumentClient.QueryOutput> {
    return (await this.documentClient()).query(params).promise().then((result) => {
      return {
        Items: result.Items,
        Count: result.Count,
        LastEvaluatedKey: result.LastEvaluatedKey
      }
    }).catch((e) => {
      throw e
    })
  }

  async scan (params: AWS.DynamoDB.DocumentClient.ScanInput): Promise<AWS.DynamoDB.DocumentClient.ScanOutput> {
    return (await this.documentClient()).scan(params).promise().then((result) => {
      return result
    })
  }
  async update (params: AWS.DynamoDB.DocumentClient.UpdateItemInput): Promise<AWS.DynamoDB.DocumentClient.UpdateItemOutput> {
    return (await this.documentClient()).update(params).promise()
  }

  async put (params: AWS.DynamoDB.DocumentClient.PutItemInput): Promise<AWS.DynamoDB.DocumentClient.PutItemOutput> {
    return (await this.documentClient()).put(params).promise()
  }
  async delete (params: AWS.DynamoDB.DocumentClient.DeleteItemInput): Promise<AWS.DynamoDB.DocumentClient.DeleteItemOutput> {
    return (await this.documentClient()).delete(params).promise()
  }

  private async documentClient (): Promise<AWS.DynamoDB.DocumentClient> {
    // TODO サインアウト時に認証情報を消す機構が必要…？
    // Auth.signOut()しても作成されたDocumentClientの認証情報は残っていて取得できてしまう
    try {
      let cred = await Auth.currentUserCredentials()
      return new AWS.DynamoDB.DocumentClient({
        region: 'ap-northeast-1',
        credentials: Auth.essentialCredentials(cred)
      })
    } catch (e) {
      throw e
    }
  }
}
